import { render, staticRenderFns } from "./damageTypeManage.vue?vue&type=template&id=d16c9244&scoped=true&"
import script from "./damageTypeManage.vue?vue&type=script&lang=js&"
export * from "./damageTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./damageTypeManage.vue?vue&type=style&index=0&id=d16c9244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16c9244",
  null
  
)

export default component.exports